module.exports = __webpack_public_path__ + "img/dinner.012822a5.jpg";